import styled, { createGlobalStyle } from 'styled-components'
import Wrapper from 'common/wrapper'

const FontFace = createGlobalStyle`
  @font-face {
    font-family: charter;
    src: url(/fonts/charter/webfonts/charter_regular-webfont.eot);
    src: local('Charter'),
          url(/fonts/charter/webfonts/charter_regular-webfont.woff) format('woff'),
          url(/fonts/charter/webfonts/charter_regular-webfont.ttf) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
`

const QuoteStyled = styled.section`
  background: #11102C;
  font-family: charter, system-ui, sans-serif;
  text-align: center;
  padding-block-end: 24px;
  padding-block-start: 24px;
  blockquote {
    font-size: 21px;
    line-height: 34px;
  }
  .quote-container {
    max-inline-size: 350px;
    margin: 0 auto;
  }
  .quotation-mark {
    display: block;
    color: var(--turquoise);
    text-align: left;
    &.bottom {
      text-align: left;
      transform: rotateZ(180deg);
    }
  }
  .quote-author {
    font-size: 18px;
    line-height: 30px;
  }
  @media(min-width: 768px) {
    padding-block-end: 40px;
    padding-block-start: 40px;
    .quote-container {
      max-inline-size: initial;
      margin: 0 auto;
    }
    svg {
      width: 48px;
      height: 48px;
    }
    blockquote {
      font-size: 28px;
      line-height: 47px;
    }
    .quote-author {
      font-size: 21px;
      line-height: 34px;
    }
  }
`

function QuotationMark() {
  return (
    <svg width="28" height="25" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.27463 3.95445V0.525879C6.16738 1.29808 3.84482 3.04324 2.30689 5.7614C0.768955 8.47956 0 12.1706 0 16.8348V24.5259H10.4516V14.2402H5.97908V13.1745C5.97908 10.6726 6.2537 8.65716 6.80296 7.1282C7.35223 5.59923 8.17611 4.54133 9.27463 3.95445ZM26.6939 3.95445V0.525879C23.5867 1.29808 21.2641 3.04324 19.7262 5.7614C18.1883 8.47956 17.4193 12.1706 17.4193 16.8348V24.5259H27.8709V14.2402H23.3984V13.1745C23.3984 10.6726 23.673 8.65716 24.2223 7.1282C24.7715 5.59923 25.5954 4.54133 26.6939 3.95445Z" fill="var(--turquoise)" />
    </svg>
  )
}

function Quote() {
  return (
    <>
      <FontFace />
      <QuoteStyled role="region" aria-labelledby="quote">
        <Wrapper maxWidth={580}>
          <div className="quote-container">
            <span className="quotation-mark top">
              <QuotationMark />
            </span>
            <blockquote id="quote">
              Hacemos educación especializada,
              <br />
              ordenada y de calidad.
            </blockquote>
            <span className="quotation-mark bottom">
              <QuotationMark />
            </span>
            <h3 className="quote-author">Leonidas Esteban</h3>
          </div>
        </Wrapper>
      </QuoteStyled>
    </>
  )
}

export default Quote
